import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Loading component for Suspense fallback
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#dddddd' }}>
    <div className="w-12 h-12 border-4 border-gray-200 border-t-red-600 rounded-full animate-spin"></div>
  </div>
);

// Lazy load admin pages
const Login = lazy(() => import("./pages/Login"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const ManageProducts = lazy(() => import("./pages/ManageProducts"));
const EditProduct = lazy(() => import("./pages/EditProduct"));
const ManageCategories = lazy(() => import("./pages/ManageCategories"));
const ManageSubcategories = lazy(() => import("./pages/ManageSubcategories"));
const ManageServices = lazy(() => import("./pages/ManageServices"));
const ManageContact = lazy(() => import("./pages/ManageContact"));
const ManageCompany = lazy(() => import("./pages/ManageCompany"));
const ManageDownloads = lazy(() => import("./pages/ManageDownloads"));
const ManageCareers = lazy(() => import("./pages/ManageCareers"));
const ManageHomePage = lazy(() => import("./pages/ManageHomePage"));
const ManageBlogs = lazy(() => import("./pages/ManageBlogs"));
const BlogEditPage = lazy(() => import("./pages/BlogEditPage"));
const ManageNews = lazy(() => import("./pages/ManageNews"));
const NewsEditPage = lazy(() => import("./pages/NewsEditPage"));
const ManageEvents = lazy(() => import("./pages/ManageEvents"));
const EventEditPage = lazy(() => import("./pages/EventEditPage"));
const ManageGallery = lazy(() => import("./pages/ManageGallery"));

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster />
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/products" element={<ManageProducts />} />
            <Route path="/products/:id/edit" element={<EditProduct />} />
            <Route path="/categories" element={<ManageCategories />} />
            <Route path="/subcategories" element={<ManageSubcategories />} />
            <Route path="/services" element={<ManageServices />} />
            <Route path="/contact" element={<ManageContact />} />
            <Route path="/company" element={<ManageCompany />} />
            <Route path="/downloads" element={<ManageDownloads />} />
            <Route path="/careers" element={<ManageCareers />} />
            <Route path="/home-page" element={<ManageHomePage />} />
            <Route path="/home" element={<Navigate to="/home-page" replace />} />
            <Route path="/blogs" element={<ManageBlogs />} />
            <Route path="/blogs/:id" element={<BlogEditPage />} />
            <Route path="/news" element={<ManageNews />} />
            <Route path="/news/:id" element={<NewsEditPage />} />
            <Route path="/events" element={<ManageEvents />} />
            <Route path="/events/:id" element={<EventEditPage />} />
            <Route path="/gallery" element={<ManageGallery />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;